"use client"

import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

import { CheckCircle2, AlertCircle, Info } from "lucide-react"

export function Toaster({
  className,
  viewportClassName,
}: {
  className?: string
  viewportClassName?: string
} = {}) {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, className: toastClassName, ...props }) {
        const isDestructive = variant === 'destructive'
        const Icon = isDestructive ? AlertCircle : CheckCircle2

        return (
          <Toast key={id} variant={variant} className={className || toastClassName} {...props}>
            <div className="flex items-start gap-3 min-w-0 flex-1">
              <div className={`mt-0.5 rounded-full p-1 shrink-0 ${
                isDestructive
                  ? 'text-destructive bg-destructive/15'
                  : 'text-primary bg-primary/15'
              }`}>
                <Icon className="h-4 w-4" />
              </div>
              <div className="grid gap-0.5 min-w-0 flex-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport className={viewportClassName} />
    </ToastProvider>
  )
}
